<template>
  <div class="header-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 tel-col">
          <div class="left">
            <ul>
              <li v-if="settings.email">
                <i class="icofont-ui-email"></i>
                <a href="javascript:;" class="email-setting">
                </a>
              </li>
              <li v-if="settings.phone">
                <i class="icofont-ui-call"></i>
                <a :href="'tel:' + settings.phone" v-html="settings.phone" style="direction:ltr">
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="right">
            <ul>
              <li>
                <a href="http://gatetechs.com" target="_blank">
                  <i :class="'icofont-facebook'"></i>
                </a>
              </li>
              <li>

                <a href="http://gatetechs.com" target="_blank">
                  <i :class="'icofont-twitter'"></i>
                </a>
              </li>
              <li>

                <a href="http://gatetechs.com" target="_blank">
                  <i :class="'icofont-instagram'"></i>
                </a>
              </li>
            </ul>

            <div class="language">
              <a v-if="$i18n.locale == 'ar'" href="javascript:;" @click="change('en')" style="color: #fff;">
                English
              </a>
              <a v-if="$i18n.locale == 'en'" href="javascript:;" @click="change('ar')" style="color: #fff;">
                العربية
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderTop',
  components: {},
  data() {
    return {
      //
      socials: [],
      settings: {
        email: "info@2payme.com",
        phone: "+96592244785",
      },
      pgLoading: false,
    }
  },
  created() {
    // if (localStorage.getItem('settings.email')) {
    //   this.settings.email = localStorage.getItem('settings.email');
    // }
    // if (localStorage.getItem('settings.phone')) {
    //   this.settings.phone = localStorage.getItem('settings.phone');
    // }

    if (localStorage.getItem('locale') != 'ar') {
      this.switchLang('en');
    } else {
      this.switchLang('ar');
    }
  },
  methods: {
    //
    switchLang: function (lang) {
      if (lang == 'ar') {
        localStorage.setItem('locale', 'ar');
      } else {
        localStorage.setItem('locale', 'en');
      }
    },
    //
    change: function (lang) {
      this.switchLang(lang);
      window.location.reload();
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.email-setting {
  margin: auto 5px;
}
</style>
